import WYSIWYG from '@components/ui/WYSIWYG/WYSIWYG'
import config from '@config/seo_meta.json'
import cn from 'clsx'
import Image from 'next/image'
interface Props {
  slice: any
}

const StepByStepBlock = ({ slice }: Props) => {
  const title = slice?.primary?.title
  const stepTitleRichText = slice?.primary?.stepTitleRichText
  const stepTitle = slice?.primary?.step_title
  const stepDescription = slice?.primary?.step_description
  const optionalTitle = slice?.primary?.optional_title
  const optionalDescription = slice?.primary?.optional_description
  const imageUrl = slice?.primary?.image?.url
  const imageAlt = slice?.primary?.image?.alt
  const textAlign = slice?.primary?.text_align

  return (
    <div
      className={cn(
        `grid w-full grid-cols-4 gap-x-6 gap-y-8 bg-brand-light-grey  py-10 lg:grid-cols-12 lg:gap-y-0 lg:gap-x-8 lg:py-16`
      )}
    >
      {title && (
        <div className="heading-mobile-3 col-span-4 block lg:hidden">
          {title}
        </div>
      )}
      <div
        className={cn(
          `col-span-4 lg:col-span-5`,
          { 'order-2 lg:order-1 ': textAlign == 'Left' },
          { 'order-2': textAlign == 'Right' }
        )}
      >
        <div className="flex h-full flex-col justify-between">
          {title && (
            <div className="heading-mobile-3 lg:heading-3 hidden lg:block">
              {title}
            </div>
          )}

          <div className="mt-auto flex flex-col gap-6">
            {stepTitleRichText?.[0]?.text ? (
              <WYSIWYG content={stepTitleRichText} />
            ) : (
              stepTitle && (
                <div className="heading-mobile-3 lg:heading-3">{stepTitle}</div>
              )
            )}
            {stepDescription && (
              <div className="stepDescription">
                <WYSIWYG content={stepDescription} />
              </div>
            )}
            {optionalTitle && optionalDescription && (
              <div className="optionalSection flex flex-col gap-4">
                <div className="body-1-bold">{optionalTitle}</div>
                <div className=" border-b-1 border-ui-dark-grey"></div>
                <div className="optionalDescription">
                  <WYSIWYG content={optionalDescription} />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div
        className={cn(
          `col-span-4  lg:col-span-6`,
          { 'order-1 lg:order-2 lg:col-start-7': textAlign == 'Left' },
          { 'order-1': textAlign == 'Right' }
        )}
      >
        <div className="relative aspect-square w-full">
          <Image
            fill
            placeholder="blur"
            blurDataURL={`${imageUrl}&blur=500`}
            style={{ objectFit: 'cover' }}
            src={imageUrl || '/product-img-placeholder.svg'}
            alt={imageAlt || config.openGraph.images[0].alt}
          />
        </div>
      </div>
      <style jsx global>
        {`
          .stepDescription .wysiwyg ul li,
          .stepDescription .wysiwyg ol li {
            list-style-position: outside;
            list-style-type: ;
            margin-left: 24px;
            padding-bottom: 24px;
          }
          .stepDescription .wysiwyg ul li:last-child,
          .stepDescription .wysiwyg ol li:last-child {
            padding-bottom: 0px;
          }
          .optionalSection .wysiwyg ul li {
            list-style-position: outside;
            list-style-type: ;
            margin-left: 24px;
            padding-bottom: 24px;
          }
          .optionalSection .wysiwyg ul li:last-child {
            padding-bottom: 0px;
          }
        `}
      </style>
    </div>
  )
}

export default StepByStepBlock
